import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from 'i18next';
import { normalizeLanguage } from '../config/languages';

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        if (process.env.NODE_ENV !== 'production') {
            return;
        }

        const url = window.location.href;
        // Read off the singleton, not a hook: as a dep it would fire a duplicate page view
        const language = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'page_view',
                page_path: location.pathname,
                page_search: location.search,
                language,
            });
        }

        const metrikaId = Number(process.env.REACT_APP_METRIKA_ID);
        if (window.ym && metrikaId) {
            window.ym(metrikaId, 'hit', url, { params: { language } });
        }
    }, [location.pathname, location.search]);
};
